// Detalles de contrato

import React from "react";
import {
  Button,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Typography,
  Box
} from "@mui/material";
import { getServiceTypeLabel } from "./ServiceType";
import { formatMX, formatMXDateTime } from '../util/DateUtil';

export default function ContractDetails({ contract, onBack }) {
  if (!contract) {
    return (
      <Box sx={{ maxWidth: 800, margin: "20px auto" }}>
        <Button
          sx={{ mb: 2, backgroundColor: "#3f74b1", color: "#fff", "&:hover": { backgroundColor: "#364f6b" } }}
          onClick={onBack}
          variant="contained"
        >
          Volver
        </Button>
        <Typography>No se ha seleccionado ningún contrato.</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ maxWidth: 800, margin: "20px auto" }}>
      <Button
        sx={{ mb: 2, backgroundColor: "#3f74b1", color: "#fff", "&:hover": { backgroundColor: "#364f6b" } }}
        onClick={onBack}
        variant="contained"
      >
        Volver
      </Button>

      <TableContainer sx={{ marginBottom: "20px" }}>
        <Table sx={{ '& .MuiTableCell-root': { borderBottom: '1px solid #eaeaea', py: 1.5 } }}>
          <TableBody>
            <TableRow>
              <TableCell><strong>ID</strong></TableCell>
              <TableCell>{contract.id}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell><strong>Organización:</strong></TableCell>
              <TableCell>{contract.organizationName}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell><strong>Cliente:</strong></TableCell>
              <TableCell>{contract.clientId}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell><strong>Cotización:</strong></TableCell>
              <TableCell>{contract.quotationId}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell><strong>Descripción:</strong></TableCell>
              <TableCell>{contract.description}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell><strong>Número de elementos:</strong></TableCell>
              <TableCell>{contract.elementsNumber}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell><strong>Número de supervisores:</strong></TableCell>
              <TableCell>{contract.supervisorsNumber}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell><strong>Tipo de servicio:</strong></TableCell>
              <TableCell>{getServiceTypeLabel(contract.serviceType)}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell><strong>Observaciones:</strong></TableCell>
              <TableCell>{contract.notes}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell><strong>Fecha de empiezo:</strong></TableCell>
              <TableCell>{formatMX(contract.startDate)}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell><strong>Fecha de fin de contrato:</strong></TableCell>
              <TableCell>{formatMX(contract.endDate)}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell><strong>Fecha de creación:</strong></TableCell>
              <TableCell>{formatMXDateTime(contract.createdAt)}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell><strong>Última actualización:</strong></TableCell>
              <TableCell>{formatMXDateTime(contract.updatedAt)}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell><strong>Estatus:</strong></TableCell>
              <TableCell>{contract.status}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
